export default __webpack_public_path__ + "static/media/logout.b1f9d620.svg";